import {DatabaseNotification} from "@/notification/interfaces/DatabaseNotification";
import {parseAgendaDate} from "@/agenda/lib/agendaTime";

type DatabaseNotificationRoute = {
    name: string;
    params?: Record<string, any>;
    query?: Record<string, string | number>;
};

export default {
    /**
     * Generate the navigation route for a given notification.
     */
    generateRoute(notification: DatabaseNotification): DatabaseNotificationRoute | null {
        switch (notification.type) {
            case 'sharingRequest':
            case "hospitalPatientFileCreated":
                return {
                    name: 'hospital',
                };
            case "sequence_no_credit_alert":
                return {
                    name: 'patient-administration.communication'
                };
            case "surveyCompleted":
                return {
                    name: 'patient-administration.surveys'
                };
            case "registrationRequest":
                return {
                    name: 'patient-administration.application.pending-customers'
                };
            case "healthcenterGroupCreatedPush":
                return {
                    name: 'disruption-logistics.healthcenter-groups'
                };
            case "availableAgainHealthcenter":
                return {
                    name: 'disruption-logistics.disruptions'
                };
            case 'sellinOffer':
                return {
                    name: 'disruption-logistics.disruption-alerts'
                };
            case 'appointmentCreatedPreferenceBased':
                // The agenda anchors on the day and opens the detail; without
                // a date (older rows) it opens on today.
                return {
                    name: 'agenda',
                    query: {
                        appointmentId: notification.data.resource_id,
                        ...(notification.data.start_at
                            ? {date: parseAgendaDate(notification.data.start_at).format('YYYY-MM-DD')}
                            : {})
                    }
                };
            default:
                return null;
        }
    }
};
